import React from 'react';
import CanvasRefactored from './CanvasRefactored';
import { CanvasProps } from '../types/Shape';

const Canvas: React.FC<CanvasProps> = ({ width, height }) => {
  return <CanvasRefactored width={width} height={height} />;
};

export default Canvas;